<template>
  <div class="content-block">
    <table class="asd-table">
      <thead>
        <tr class="table-heading">
          <th></th>
          <th>
            {{ $t('common.name') }}
          </th>
          <th>
            Aktivní do
          </th>
          <th>
            Obsahuje vlastnosti
          </th>
        </tr>
      </thead>
      <tbody>
        <TaskTypeRow v-for="taskType in sortedTaskTypes" :key="taskType.id" :taskTypeId="taskType.id"></TaskTypeRow>
      </tbody>
    </table>
  </div>
</template>

<script>
import TaskTypeRow from 'CORE/components/task/type/row'
import { czSorter } from 'CORE/utils/sorters'
import { get, chain } from 'lodash'

export default {
    name: 'TaskTypeTable',
    components: {
        TaskTypeRow,
    },
    computed: {
        sortedTaskTypes() {
            return chain(this.$store.getters.taskTypes)
                .sortWith((a, b) => czSorter('asc')(...[a, b].map(c => get(c, 'name'))))
                .orderBy(['validUntil'], ['desc'])
                .value()
        },
    },
}
</script>
